import React, { Component } from 'react'
import Link from 'gatsby-link'
import bssLogo from '@assets/svgs/bss-logo.svg'
import { homeRoute } from '@constants/routes'

class HeaderLogo extends Component {
  render () {
    return (<Link to={homeRoute} onClick={this.logoClick}>
      <img data-src={bssLogo} className='lazyload' width='101' height='35' alt='BSS Industrial Pipeline & Heating Solutions' />
    </Link>)
  }
}
export default HeaderLogo



// WEBPACK FOOTER //
// ./src/components/HeaderLogo/HeaderLogo.js